<template style="height: 100%;">
  <div class="Counselor CounselorIndex CommonContentSingle-white">
    <el-dialog :title="$t('original.languages260')" :visible.sync="dialogTableVisible" width="38%">
      <div>
        <table style="background: rgb(245, 247, 250);border-radius: 18px;width: 100%;">
          <tr>
            <td class="td_left">{{ $t('original.languages185') }}：</td>
            <td class="td_right">{{ CounselorDetail.RealName }}</td>
          </tr>
          <tr>
            <td class="td_left">{{ $t('original.languages71') }}：</td>
            <td class="td_right">{{ CounselorDetail.StartTime }}</td>
          </tr>
          <tr>
            <td class="td_left">{{ $t('original.languages186') }}：</td>
            <td class="td_right">{{ CounselorDetail.EndTime }}</td>
          </tr>
          <tr>
            <td class="td_left">{{ $t('original.languages187') }}：</td>
            <td class="td_right">
              <div v-if="appointmentList.length > 0">
                <div v-for="item in appointmentList" :key="item.index">
                  <span style="margin-left: 20px">{{ item.RealName }}</span>
                  <span style="margin-left: 20px">{{ item.SchedulDate }}</span>
                </div>
              </div>
              <div v-else>{{ $t('original.languages188') }}</div>
            </td>
          </tr>
          <tr>
            <td class="td_left">{{ $t('original.languages189') }} ：</td>
            <td class="td_right">
              {{
                  CounselorDetail.LeaveReason == null ||
                    CounselorDetail.LeaveReason == ''
                    ? $t('original.languages261')
                    : CounselorDetail.LeaveReason
              }}
            </td>
          </tr>
        </table>

        <table style="margin-top=20px; width:100%">
          <tr>
            <td class="td_left">{{ $t('original.languages190') }}</td>
            <td class="td_right" :style="
              CounselorDetail.Status == 0
                ? 'color: rgba(0, 136, 255, 1);'
                : CounselorDetail.Status == -1
                  ? 'color: rgba(242, 75, 78, 1);'
                  : CounselorDetail.Status == 1
                    ? 'color: rgba(21, 191, 109, 1); '
                    : 'color: rgba(141, 141, 141, 1);'
            ">
              {{
                  CounselorDetail.Status == 0
                    ? $t('original.languages227')
                    : CounselorDetail.Status == -1
                    ? $t('original.languages204')
                      : CounselorDetail.Status == 1
                    ? $t('original.languages203')
                    : $t('original.languages205')
              }}
            </td>
          </tr>
          <tr v-if="CounselorDetail.Status == -1">
            <td class="td_left"> {{ $t('original.languages215') }}</td>
            <td class="td_right">{{ CounselorDetail.AefuseCause }}</td>
          </tr>
          <tr v-if="CounselorDetail.Status == 1">
            <td class="td_left"> {{ $t('original.note') }}</td>
            <td class="td_right">{{ CounselorDetail.AefuseCause }}</td>
          </tr>
          <tr v-if="CounselorDetail.Status == -1 || CounselorDetail.Status == 1">
            <td class="td_left"> {{ $t('original.languages192') }}</td>
            <td class="td_right">{{ CounselorDetail.Approver }}</td>
          </tr>

          <tr v-if="CounselorDetail.Status == -1 || CounselorDetail.Status == 1">
            <td class="td_left"> {{ $t('original.languages193') }}</td>
            <td class="td_right">
              {{ CounselorDetail.ApproverTime}}
            </td>
          </tr>
        </table>

        <div class="buttons" style="width: 100%" v-if="CounselorDetail.Status == 0">
          <el-button @click="dialogTableVisible = false">{{ $t('original.cancel') }}</el-button>
          <el-button type="primary" @click="UpdateStatus(CounselorDetail.UserID,CounselorDetail.LeaveID,CounselorDetail.Status)">
            {{ $t('original.languages253') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :title="$t('original.languages262')" :visible.sync="dialogFormVisible" width="45%">
      <p style="padding:20px;color: red;">单次最多能申请一个值班日的请假，如需申请超过一个值班日的请假，请为每个值班日提交单独申请!</p>
      <el-form ref="CounselorFrom" :model="CounselorFrom" label-width="150px" prop="CounselorFrom">
        <el-form-item :label="$t('original.languages198')">
          <el-date-picker style="width: 35%" v-model="CounselorFrom.startdate" type="date" @change="selectTime()"
            value-format="yyyy-MM-dd" :placeholder="$t('original.languages263')"></el-date-picker>
          <el-time-select style="width: 35%; margin-left: 10px" v-model="CounselorFrom.starttime" @change="selectTime()"
            :picker-options="{
              start: '00:30',
              step: '00:30',
              end: '23:30',
            }" :placeholder="$t('original.languages264')"></el-time-select>
        </el-form-item>

        <el-form-item :label="$t('original.languages199')">
          <el-date-picker style="width: 35%" v-model="CounselorFrom.enddate" @change="selectTime()"
            value-format="yyyy-MM-dd" type="date" :placeholder="$t('original.languages263')"></el-date-picker>

          <el-time-select style="width: 35%; margin-left: 10px" v-model="CounselorFrom.endtime" @change="selectTime()"
            :picker-options="{
              start: '00:30',
              step: '00:30',
              end: '23:30',
            }" :placeholder="$t('original.languages264')"></el-time-select>
        </el-form-item>

        <el-form-item class="appointment" v-if="appointmentList.length > 0" :label="$t('original.languages265')">
          <div v-for="item in appointmentList" :key="item.index">
            <span style="margin-left: 20px">{{ item.RealName }}</span>
            <span style="margin-left: 20px">{{ item.SchedulDate }}</span>
          </div>
        </el-form-item>

        <el-form-item :label="$t('original.languages189')">
          <el-input style="width: 72%" type="textarea" v-model="CounselorFrom.LeaveReason" resize="none"></el-input>
        </el-form-item>
        <div class="buttons">
          <el-button @click="dialogFormVisible = false" type="warning">
             {{ $t('original.cancel') }}
          </el-button>
          <el-button @click="onSubmit()" type="primary" :loading="submitload">{{ $t('original.languages266') }} </el-button>
        </div>
      </el-form>
    </el-dialog>

    <div>
      <el-button style="margin: 0px 0px 10px 0px" type="primary" @click="dialogFormVisible = true">
        {{ $t('original.languages267') }}
      </el-button> 
      <el-table ref="multipleTable" v-loading="load" :element-loading-text="$t('original.languages22')"
        element-loading-spinner="el-icon-loading" :data="tableData" tooltip-effect="dark" style="width: 100%"
        @sort-change="sorting">
        <el-table-column :label="$t('original.The_serial_number')" width="100px">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="UserID" :label="$t('original.account')"></el-table-column>
        <el-table-column prop="RealName" :label="$t('original.name')"></el-table-column>

        <el-table-column :label="$t('original.languages71')">
          <template slot-scope="scope">
            <i class="el-icon-time"></i>
            {{ scope.row.StartTime }}
          </template>
        </el-table-column>

        <el-table-column :label="$t('original.languages186')">
          <template slot-scope="scope">
            <i class="el-icon-time"></i>
            {{ scope.row.EndTime }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('original.languages147')">
          <template slot-scope="scope">
            <span :class="scope.row.Status == 0
                ? 'Statusblue'
                : scope.row.Status == 1
                  ? 'Statusgreen'
                  : scope.row.Status == -1
                    ? 'Statusred'
                    : 'Statusgray'
            ">
              {{
                  scope.row.Status == 0
                  ? $t('original.languages227')
                    : scope.row.Status == 1
                  ? $t('original.languages203')
                      : scope.row.Status == -1
                  ? $t('original.languages204')
                  : $t('original.languages205')
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('original.languages49')" width="180" fixed="right" align="center">
          <template slot-scope="scope">
            <span @click="dialogTableVisible = true;
            getdetails(scope.row);" class="table_btn">
               查看
            </span>
            <span v-if="scope.row.Status == 0" class="table_btn" @click="
              UpdateStatus(scope.row.UserID,scope.row.LeaveID,scope.row.Status)">
               {{ $t('original.languages253') }}
            </span>

          </template>
        </el-table-column>
      </el-table>
      <div class="block">
        <el-pagination @current-change="handleCurrentChange"
          :current-page.sync="currentPage1" :page-size="10" layout="total, prev, pager, next" :total="totalnumber">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import add from '../Measurement/add.vue';
export default {
  components: { add },
  data() {
    return {
      dialogFormVisible: false,
      dialogTableVisible: false,
      loadings: false,
      CounselorFrom: {
        //添加操作
        startdate: '',
        starttime: '',
        enddate: '',
        endtime: '',
        LeaveReason: '',
      },
      CounselorDetail: {
        LeaveID: '',
        UserID: '',
        RealName: '', //名字
        StartTime: '', //开始时间
        EndTime: '', //结束时间
        LeaveReason: '', //请假原因
        Status: '', //审批状态
        AefuseCause: '',
        Approver: '',
        ApproverTime: '',
      },
      appointmentList: [],
      tableData: [],
      totalnumber: 0,
      CounselorWorkingData: [],
      CounselorForwardData: [],
      opt: '',
      load: false,
      currentPage1: 1,
      ruleForm: {
        LeaveID: '',
        UserID: '',
        StartTime: '',
        EndTime: '',
        Status: '',
        LeaveReason: '',
        ApproveRemark: '',
        RealName: '',
      },
      Status: [
        {
          value: '已同意',
          label: '已同意',
        },
        {
          value: '已拒绝',
          label: '已拒绝',
        },
        {
          value: '申请请假',
          label: '申请请假',
        },
      ],
      form: {
        entity: sessionStorage.getItem('entity'),
        RealName: '',
        UserID: '',
        DeptName: '',
        Status: '',
        pageSize: '10',
        pageIndex: '1',
      },
      submitload:false,
    };
  },
  mounted: function () {
    this.sorting();
    this.$Http_Post('ConsultSubscribe/GetCounselor').then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.opt = res.Data;
      }
    });
  },
  methods: {
    sorting() {
      this.loading(this.form);
    },

    loading(form) {
      this.load = true;
      this.$Http_Post('ConsultSubscribe/ShowCounselorLeave', {
        form,
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.load = false;
          if (res.Data.Lists.length > 0) {
            this.tableData = res.Data.Lists;
            this.totalnumber = Number(res.Data.Counts);
            this.isAble = true;
            setTimeout(function () {
              this.isAble = false;
            }, 2000);
          } else {
            if (Number(form.pageIndex) > 1) {
              form.pageIndex = form.pageIndex - 1;
              this.currentPage1 = this.currentPage1 - 1;
              this.loading(this.form);
            } else {
              this.tableData = res.Data.Lists;
              this.totalnumber = Number(res.Data.Counts);
            }
          }
        } else {
          this.$notify.closeAll();
          this.$notify.error({
            title: this.$t('original.languages168'),
            message: res.data.Message,
          });
        }
      });
    },

    UpdateStatus(UserID, LeaveID, Status) {
      if (Status != 0) {
        return false;
      } else {
        this.$confirm(this.$t('original.languages268'), this.$t('original.languages63'), {
          confirmButtonText: this.$t('original.languages59'),
          cancelButtonText: this.$t('original.cancel'),
          type: 'warning',
        })
          .then(() => {
            this.$Http_Post('ConsultSubscribe/UpdateCounselorLeave', {
              UserId: UserID,
              LeaveID: LeaveID,
              Status: '-2',
            }).then((res) => {
              if (res.Code == 200 || res.Code == 0) {
                for (let index = 0; index < this.tableData.length; index++) {
                  if (this.tableData[index].LeaveID == LeaveID) {
                    this.tableData[index].Status = -2;
                  }
                }
                this.$message({
                  message: this.$t('original.languages259'),
                  type: 'success',
                });
                this.dialogTableVisible = false;
              } else {
                this.$message.error(this.$t('original.languages259'));
              }
            });
          })
          .catch(() => { });
      }
    },

    selectTime() {
      let startTime = new Date(
        Date.parse(
          this.CounselorFrom.startdate +
          ' ' +
          this.CounselorFrom.starttime +
          ':00'
        )
      );
      let endTime = new Date(
        Date.parse(
          this.CounselorFrom.enddate + ' ' + this.CounselorFrom.endtime + ':00'
        )
      );
      //如果时间都有值进行查询
      if (
        this.CounselorFrom.startdate != '' &&
        this.CounselorFrom.starttime != '' &&
        this.CounselorFrom.enddate != '' &&
        this.CounselorFrom.endtime != ''
      ) {
        if (startTime > endTime) {
          this.$message({
            message: this.$t('original.languages269'),
            type: 'warning',
          });
          this.CounselorFrom.enddate = '';
          this.CounselorFrom.endtime = '';
        } else {
          this.selectappointment(
            this.CounselorFrom.startdate +
            ' ' +
            this.CounselorFrom.starttime +
            ':00',

            this.CounselorFrom.enddate +
            ' ' +
            this.CounselorFrom.endtime +
            ':00'
          );
        }
      }
    },

    selectappointment(starTime, endTime) {
      this.$Http_Post('ConsultSubscribe/GetLeaveAppointment', {
        starTime: starTime,
        endTime: endTime,
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.appointmentList = res.Data;
        } else {
          this.$notify.closeAll();
          this.$notify.error({
            title: this.$t('original.languages168'),
            message: res.data.Message,
          });
        }
      });
    },

    getdetails(row) {
      let StartTime = moment(row.StartTime).format('yyyy-MM-DD HH:mm:ss');
      let EndTime = moment(row.EndTime).format('yyyy-MM-DD HH:mm:ss');
      this.CounselorDetail.LeaveID = row.LeaveID;
      this.CounselorDetail.RealName = row.RealName;
      this.CounselorDetail.StartTime = StartTime;
      this.CounselorDetail.EndTime = EndTime;
      this.CounselorDetail.Status = row.Status;
      this.CounselorDetail.LeaveReason = row.LeaveReason;
      this.CounselorDetail.AefuseCause = row.AefuseCause;
      this.CounselorDetail.Approver = row.Approver;
      this.CounselorDetail.ApproverTime = row.ApproverTime;
      this.CounselorDetail.UserID = row.userID;
      this.selectappointment(StartTime, EndTime);
    },
    submitForm(formName) {
      this.$Http_Post('ConsultSubscribe/AddCounselorLeave', this.ruleForm)
        .then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            sessionStorage.setItem('department', '');
            this.nav_list = res.Data;
            this.Global.request_successful(res.Message);
            this.drawer = false;
            this.sorting();
          } else {
            this.Global.request_failure(res.Message);
          }
        })
        .catch((err) => {
          this.$message({
            type: 'error',
            message: err.message,
          });
        });
    },
    onSubmit() {
      if (this.CounselorFrom.startdate != '' && this.CounselorFrom.starttime != '' && this.CounselorFrom.enddate != '' && this.CounselorFrom.endtime != '' && this.CounselorFrom.LeaveReason != '') {
        this.submitload=true;


        var time1 = new Date(this.CounselorFrom.startdate +' ' +  this.CounselorFrom.starttime +':00')
        var time2 = new Date(this.CounselorFrom.enddate +' ' + this.CounselorFrom.endtime+':00')
        
        if(time2.getTime() - time1.getTime() <= 86400000){
          this.$Http_Post('ConsultSubscribe/AddCounselorLeave', {
            StartTime:this.CounselorFrom.startdate + ' ' + this.CounselorFrom.starttime + ':00',
            EndTime:this.CounselorFrom.enddate + ' ' + this.CounselorFrom.endtime + ':00',
            LeaveReason: this.CounselorFrom.LeaveReason,
          }).then((res) => {
            if (res.Code == 200 || res.Code == 0) {
              this.form.pageIndex = 1;
              this.currentPage1 = 1;
              this.loading(this.form);
              this.dialogFormVisible = false;
              this.CounselorFrom.startdate = '';
              this.CounselorFrom.starttime = '';
              this.CounselorFrom.enddate = '';
              this.CounselorFrom.endtime = '';
              this.CounselorFrom.LeaveReason = '';
            } else {
              this.$message({
                message: res.Message,
                type: 'warning',
              });
            }
            this.submitload=false;
          });
        }else{
          this.$message({
            showClose: true,
            message: '单次最多能申请一个值班日的请假，如需申请超过一个值班日的请假，请为每个值班日提交单独申请!',
            type: 'warning',
          });
          this.submitload=false;
        }

        
      } else {
        this.$message({
          showClose: true,
          message: this.$t('original.languages270'),
          type: 'warning',
        });
      }
    },
    handleEdit(index, row) {
      this.drawer1 = true;
      this.$Http_Post('ConsultSubscribe/SelectCounselorLeave', {
        LeaveID: row.LeaveID,
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.load = false;
          this.ruleForm.LeaveID = res.Data.LeaveID;
          this.ruleForm.UserID = res.Data.UserID;
          this.ruleForm.StartTime = res.Data.StartTime;
          this.ruleForm.EndTime = res.Data.EndTime;
          this.ruleForm.LeaveReason = res.Data.LeaveReason;
          this.ruleForm.ApproveRemark = res.Data.ApproveRemark;
          this.ruleForm.RealName = res.Data.RealName;
        } else {
          this.$notify.error({
            title: this.$t('original.languages168'),
            message: res.Message,
          });
        }
      });

      this.$Http_Post('ConsultSubscribe/ShowCounselorWorking', {LeaveID: row.LeaveID,UserID: row.UserID}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.CounselorWorkingData = res.Data;
        } else {
          this.$notify.error({
            title: this.$t('original.languages168'),
            message: res.Message,
          });
        }
      });

      this.$Http_Post('ConsultSubscribe/ShowCounselorForward', {LeaveID: row.LeaveID,UserID: row.UserID}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.CounselorForwardData = res.Data;
        } else {
          this.$notify.error({
            title: this.$t('original.languages168'),
            message: res.Message,
          });
        }
      });
    },
    handleEdit2(index, row) {
      this.drawer2 = true;
      this.$Http_Post('ConsultSubscribe/SelectCounselorLeave', {LeaveID: row.LeaveID}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.load = false;
          this.ruleForm.LeaveID = res.Data.LeaveID;
          this.ruleForm.UserID = res.Data.UserID;
          this.ruleForm.StartTime = res.Data.StartTime;
          this.ruleForm.EndTime = res.Data.EndTime;
          this.ruleForm.LeaveReason = res.Data.LeaveReason;
          this.ruleForm.ApproveRemark = res.Data.ApproveRemark;
          this.ruleForm.RealName = res.Data.RealName;
          this.ruleForm.Status = res.Data.Status;
        } else {
          this.$notify.error({
            title: this.$t('original.languages168'),
            message: res.Message,
          });
        }
      });
      this.$Http_Post('ConsultSubscribe/ShowCounselorWorking', {LeaveID: row.LeaveID,UserID: row.UserID}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.CounselorWorkingData = res.Data;
        } else {
          this.$notify.error({
            title: this.$t('original.languages168'),
            message: res.Message,
          });
        }
      });
      this.$Http_Post('ConsultSubscribe/ShowCounselorForward', {
        LeaveID: row.LeaveID,
        UserID: row.UserID,
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.CounselorForwardData = res.Data;
        } else {
          this.$notify.error({
            title: this.$t('original.languages168'),
            message: res.Message,
          });
        }
      });
    },
    btn_submit() {
      this.$Http_Post('ConsultSubscribe/UpdateCounselorLeave',this.ruleForm).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.nav_list = res.Data;
          this.$notify({
            title: this.$t('original.languages167'),
            message: res.Message,
            type: 'success',
          });
          this.drawer = false;
        } else {
          this.$notify.error({
            title: this.$t('original.languages168'),
            message: res.Message,
          });
        }
      });
    },
    handleCurrentChange(val) {
      this.form.pageIndex = val;
      this.loading(this.form);
    },
  },
};
</script>
<style>
.text {font-size: 6px;}
.Counselor .xforxm .el-form-item {margin-bottom: 10px;float: left;width: 33%;}
.Counselor .xforxm {height: 120px;}
.Counselor .el_form {width: 80%;margin-left: 30px;}
.cldrawer h2 {padding: 18px;font-size: 18px;}
.Counselor .cldrawer_btn {margin-left: 30%;margin-top: 40px;padding-bottom: 50px;}
.caozuo {margin-left: 10px;color: var(--themecolor) !important;;cursor: pointer;}
.CounselorIndex .Statusgray {border-radius: 4px;padding: 5px 10px;background: rgba(141, 141, 141, 0.1);color: rgba(141, 141, 141, 1);}
.CounselorIndex .Statusblue {border-radius: 4px;padding: 5px 10px;background: rgba(29, 154, 255, 0.1);color: rgba(29, 154, 255, 1);}
.CounselorIndex .Statusgreen {border-radius: 4px;background-color: rgba(21, 191, 109, 0.1);color: rgba(21, 191, 109, 1);padding: 5px 10px;}
.CounselorIndex .Statusred {border-radius: 4px;background-color: rgba(242, 75, 78, 0.1);color: rgba(242, 75, 78, 1);padding: 5px 10px;}
.CounselorIndex .block {float: right;margin-top: 0px;}
.CounselorIndex .td_left {font-size: 16px;text-align: right;width: 25%;padding: 10px 20px;color: rgba(92, 92, 92, 1);}
.CounselorIndex .td_right {font-size: 16px;width: 74%;padding: 10px 20px;color: rgba(40, 40, 40, 1);}
.CounselorIndex .appointment .el-form-item__content {height: 180px;color: rgba(40, 40, 40, 1);overflow-y: auto;width: 460px;background-color: rgba(240, 240, 240, 1);}
.CounselorIndex .buttons {width: 100%;margin-left: 0px;text-align: center;}
</style>
